import Config from "../../../core/config/Config";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import BackendService from "../../backend/controller/BackendService";
import PlayerModel from "../../player/model/PlayerModel";
import ConversationReflectionPlayer from "./ConversationReflectionPlayer";

export default class ConversationReflectionPlayerFactory {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {BackendService} backendService 
     * @param {Config} config 
     * @param {PlayerModel} playerModel 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(dispatcher, backendService, config, playerModel, variableManager) {
        this._dispatcher = dispatcher;
        this._backendService = backendService;
        this._config = config;
        this._playerModel = playerModel;
        this._variableManager = variableManager;
    }

    create() {
        return new ConversationReflectionPlayer(this._dispatcher, this._backendService, this._config, this._playerModel, this._variableManager);
    }
}